import React, { FC, useState } from 'react'
import { Button, Card, Flex, Typography } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons'
import { ModuleAudioExerciseDto, ModuleExampleExerciseDto } from '../../../../../shared/types/api'
import * as API_COURSES from '../../../../../shared/http/courses'


const { Text } = Typography

interface AudioPlayerProps {
    ex: ModuleExampleExerciseDto,
    removeExercise: (exId: number) => void
}

export const ExampleCard: FC<AudioPlayerProps> = ({ ex, removeExercise }) => {

    const [showTranslate, setShowtranslate] = useState<boolean>(false)

    const deleteAudio = () => {
        if (ex.id) {
            API_COURSES.deleteTestExercise(ex.id).then(resp => {
                removeExercise(Number(ex.id))
            })
        }
    }

    return (
        <Card style={{ marginTop: 16 }}>
            <Flex align={'center'} gap={16}>
                <Text>{ex.data.title}</Text>
                <a onClick={deleteAudio}>Удалить</a>
            </Flex>
            <Flex style={{ marginTop: 18 }} vertical={true} gap={8}>
                <Text>{ex.data.text}</Text>
                {ex.data.description &&
                !showTranslate ? <a onClick={() => setShowtranslate(true)}>Показать</a> :
                    <Text>{ex.data.description}</Text>}
            </Flex>
        </Card>
    )
}

